var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbCallbackAppointIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-callback-appoint-icon_svg__clip0_7344_3758)",
    fill: "#ED1B2E"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.852a1 1 0 112 0v1h1a4 4 0 014 4v12c0 1.11-.903 2-2.003 2H13.5a1 1 0 110-2h4.498l.002-.001v-7.999H1a1 1 0 01-1-1v-3a4 4 0 014-4h1v-1a1 1 0 112 0v1h6v-1zm-6 4v-1h6v1a1 1 0 102 0v-1h1a2 2 0 012 2v2H2v-2a2 2 0 012-2h1v1a1 1 0 002 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.707 14.56a1 1 0 10-1.414-1.415l-3 3a1 1 0 000 1.415l3 3a1 1 0 001.414-1.415l-1.293-1.293H10a1 1 0 100-2H3.414l1.293-1.293z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-callback-appoint-icon_svg__clip0_7344_3758"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 20 .852)",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgIbCallbackAppointIcon;